import React, { useState } from 'react';
import i18n from '@/i18n';
import { inferMediaReferrerPolicy } from '@/utils/externalMediaReferrerPolicy';

const ERROR_IMG_SRC =
  'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODgiIGhlaWdodD0iODgiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgc3Ryb2tlPSIjMDAwIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBvcGFjaXR5PSIuMyIgZmlsbD0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIzLjciPjxyZWN0IHg9IjE2IiB5PSIxNiIgd2lkdGg9IjU2IiBoZWlnaHQ9IjU2IiByeD0iNiIvPjxwYXRoIGQ9Im0xNiA1OCAxNi0xOCAzMiAzMiIvPjxjaXJjbGUgY3g9IjUzIiBjeT0iMzUiIHI9IjciLz48L3N2Zz4KCg==';

export function ImageWithFallback(props: React.ImgHTMLAttributes<HTMLImageElement>) {
  const [didError, setDidError] = useState(false);

  const handleError = () => {
    setDidError(true);
  };

  const { src, alt, style, className, referrerPolicy, ...rest } = props;
  const effectiveReferrer = inferMediaReferrerPolicy(typeof src === 'string' ? src : undefined, referrerPolicy);

  return didError ? (
    <div
      className={`flex h-full min-h-0 w-full items-center justify-center bg-gray-100 text-center ${className ?? ''}`}
      style={style}
    >
      <img
        src={ERROR_IMG_SRC}
        alt={i18n.t('common.imageLoadErrorAlt')}
        referrerPolicy={effectiveReferrer}
        {...rest}
        data-original-url={src}
        className="max-h-full max-w-full object-contain opacity-40"
      />
    </div>
  ) : (
    <img
      src={src}
      alt={alt}
      referrerPolicy={effectiveReferrer}
      className={className}
      style={style}
      {...rest}
      onError={handleError}
    />
  );
}
